import { Components } from '@mui/material';

export const MuiSelect: Components['MuiSelect'] = {
  defaultProps: {
    variant: 'outlined',
  },
};
